
import ViewAttachments from "components/Application/ViewAttachments"
import { useEffect, useState } from "react"
import { Row, Card, CardBody, CardFooter, CardHeader } from "reactstrap"

const ApplicationDetails = props => {
  const [attachments, setattachments] =  useState([])
  useEffect(()=>{
    excludeAttachmentsByDescription(props.attachments)
  }, [])

  function excludeAttachmentsByDescription(attachments) {
    // exclude attachments with the following descriptions
    const descriptionsToFilter = ["Draft_Terms_of_Reference", "Checklist_Review_Document", "Final_Terms_of_Reference"];
  
    // exclude the attachments that match any of the descriptions in the array
    const atts = attachments.filter(attachment => 
      !descriptionsToFilter.includes(attachment.description)
    );
    setattachments(atts)
  }
  
  return (
    <>
      <Card>
        <CardHeader className="alert-primary">REMA Appplication Details</CardHeader>
        <CardBody>
            <Row>
              <ViewAttachments attachments={attachments} />
            </Row>
            {props.appDetails}
        </CardBody>
      </Card>
    </>
  )
}

export default ApplicationDetails
